import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class GeoRequiredGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    const hasGeo = localStorage.getItem("_hasGeo") === "true";
    const hasCategory = localStorage.getItem("_hasCategory") === "true";

    if (hasGeo && hasCategory) return true;

    const pendentes: string[] = [];
    if (!hasGeo)
      pendentes.push(
        "📍 <strong>Localização no mapa</strong> — clique no mapa para posicionar o pin da sua empresa"
      );
    if (!hasCategory)
      pendentes.push(
        "🏷️ <strong>Categoria do serviço</strong> — selecione a categoria que melhor descreve seu negócio"
      );

    Swal.mixin({
      customClass: { confirmButton: "btn btn-primary" },
      buttonsStyling: false,
    }).fire({
      title: "Complete seu cadastro",
      html:
        "Para usar o sistema, você precisa preencher os seguintes itens no seu perfil:<br><br>" +
        pendentes.map((p) => `• ${p}`).join("<br>"),
      icon: "warning",
      confirmButtonText: "Ir para o perfil",
    });

    return this.router.createUrlTree(["/company-profile"]);
  }
}
